import '../scss/theme.scss';
import 'bootstrap';
import mobileMenu from './utils/hcOffcanvasNav';
import lazyload from './utils/lazyload';

import Swiper from 'swiper';
import {Navigation, Pagination, Scrollbar} from 'swiper/modules';

import 'swiper/css';

// Uncomment if google maps is used in the project
//import { loadGoogleMaps } from './utils/gmap/map';


document.addEventListener('DOMContentLoaded', () => {
    lazyload();
    mobileMenu('#primary-menu', '.hc-menu-toggle');


    const swiperContainer = document.querySelector('.carousel-collection');

    if (swiperContainer) {
        new Swiper(swiperContainer, {
            modules: [Navigation, Pagination, Scrollbar],
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1199: {
                    slidesPerView: 4,
                },
            },
        });
    }

    const blocks = document.querySelectorAll('.text-on-image-block[data-has-video="true"]');

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const block = entry.target;
            const video = block.querySelector('.text-on-image__video');

            if (video) {
                video.play();
                block.classList.add('is-playing');
            }

            obs.unobserve(block);
        });
    }, {
        threshold: 0.4
    });

    blocks.forEach(block => observer.observe(block));


    document.querySelectorAll('.before-after').forEach(block => {
        const wrapper = block.querySelector('.before-after__wrapper');
        const after = block.querySelector('.before-after__after');
        const slider = block.querySelector('.before-after__slider');
        const afterImage = block.querySelector('.before-after__after img');
        const beforeImage = block.querySelector('.before-after__img');

        const width = beforeImage.offsetWidth;

        afterImage.style.width = width + 'px';

        const move = (x) => {
            const rect = wrapper.getBoundingClientRect();
            let pos = ((x - rect.left) / rect.width) * 100;
            pos = Math.max(0, Math.min(100, pos));

            after.style.width = pos + '%';
            slider.style.left = pos + '%';
        };

        wrapper.addEventListener('mousemove', e => move(e.clientX));
        wrapper.addEventListener('touchmove', e => move(e.touches[0].clientX));
    });


    if (typeof GLightbox !== 'undefined') {
        GLightbox({
            selector: '.glightbox',
            loop: true,
            zoomable: true,
            touchNavigation: true
        });
    }



    const button = document.querySelector('.js-show-more');
    const button_container = document.querySelector('.collection-gallery__more');
    if (!button) return;

    button.addEventListener('click', function () {
        document.querySelectorAll('.collection-gallery__item.is-hidden')
            .forEach(el => el.classList.remove('is-hidden'));
        button_container.remove();
    });



    const headerSticky = document.getElementById('header-sticky');

    function onScroll() {
        console.log("scroll");
        const headerNav = document.querySelector('.header-nav');

        const offsetTop = (
            headerNav &&
            headerNav.offsetParent !== null
        )
            ? headerNav.offsetHeight
            : 0;

        if (window.scrollY > offsetTop) {
            headerSticky.classList.add('sticky');
        } else {
            headerSticky.classList.remove('sticky');
        }
    }

    window.addEventListener('scroll', onScroll);

    onScroll();

});

